"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetRequest1ToJSON = exports.CreateAssetRequest1FromJSONTyped = exports.CreateAssetRequest1FromJSON = exports.instanceOfCreateAssetRequest1 = void 0;
var runtime_1 = require("../runtime");
var AssetSubtype_1 = require("./AssetSubtype");
var AssetType_1 = require("./AssetType");
var AudioCreationProperties1_1 = require("./AudioCreationProperties1");
/**
 * Check if a given object implements the CreateAssetRequest1 interface.
 */
function instanceOfCreateAssetRequest1(value) {
    var isInstance = true;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateAssetRequest1 = instanceOfCreateAssetRequest1;
function CreateAssetRequest1FromJSON(json) {
    return CreateAssetRequest1FromJSONTyped(json, false);
}
exports.CreateAssetRequest1FromJSON = CreateAssetRequest1FromJSON;
function CreateAssetRequest1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
        'assetSubtype': !(0, runtime_1.exists)(json, 'asset_subtype') ? undefined : (0, AssetSubtype_1.AssetSubtypeFromJSON)(json['asset_subtype']),
        'name': json['name'],
        'audioCreationProperties': !(0, runtime_1.exists)(json, 'audio_creation_properties') ? undefined : (0, AudioCreationProperties1_1.AudioCreationProperties1FromJSON)(json['audio_creation_properties']),
    };
}
exports.CreateAssetRequest1FromJSONTyped = CreateAssetRequest1FromJSONTyped;
function CreateAssetRequest1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'asset_subtype': (0, AssetSubtype_1.AssetSubtypeToJSON)(value.assetSubtype),
        'name': value.name,
        'audio_creation_properties': (0, AudioCreationProperties1_1.AudioCreationProperties1ToJSON)(value.audioCreationProperties),
    };
}
exports.CreateAssetRequest1ToJSON = CreateAssetRequest1ToJSON;
